import { render, staticRenderFns } from "./ContentProfile.vue?vue&type=template&id=48f90b2e&scoped=true&"
import script from "./ContentProfile.vue?vue&type=script&lang=js&"
export * from "./ContentProfile.vue?vue&type=script&lang=js&"
import style0 from "./ContentProfile.vue?vue&type=style&index=0&id=48f90b2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f90b2e",
  null
  
)

export default component.exports